import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section>
      <h2 className="text-xl font-heading text-foreground-900 mb-5">玩家评价</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {testimonials.map((t, index) => (
          <div key={index} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`text-xs ${i < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                ></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">&ldquo;{t.content}&rdquo;</p>
            <div className="flex items-center justify-between text-xs text-foreground-400">
              <span className="font-medium text-foreground-700">{t.name}</span>
              <span>{t.date}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}